/* eslint-disable import/prefer-default-export */
/* eslint-disable no-case-declarations */
import Vue from 'vue';

const feedItemSelector = 'article, [role="article"]';

const bindFeedEvents = (feed, items) => {
  items.forEach((item) => item.addEventListener('keydown', (event) => {
    const key = event.key.toLowerCase();

    switch (key) {
      case 'pageup':
      case 'pagedown':
        const index = items.indexOf(item);
        const direction = key === 'pageup' ? -1 : 1;
        const newIndex = Math.min(Math.max(index + direction, 0), items.length - 1);
        const newItem = items[newIndex];
        newItem.focus();
        newItem.scrollIntoView({ block: 'center' });
        event.preventDefault();
        break;
      default:
        break;
    }
  }));
};

/**
 * Binds keyboard navigation events to the element, considering all descendants
 * matching `article, [role="article"]` as feed items.
 *
 * The navigation is implemented according to the WAI-ARIA Feed pattern:
 * https://www.w3.org/TR/wai-aria-practices-1.1/#feed
 *
 * Make sure the bound element has `role="feed"`.
 */
export const accessibleFeed = {
  bind(feed) {
    const items = Array
      .from(feed.querySelectorAll(feedItemSelector));
    if (!items || items.length === 0) {
      return;
    }

    bindFeedEvents(feed, items);
  },
};

Vue.directive('accessible-feed', accessibleFeed);
